import { useEffect } from 'react';

import { useUserConsent } from 'src/Services/UserConsentProvider/context';

import { identifyMixpanelUser } from '../../Services/Mixpanel';

export function useMixpanelIdentify(
  user:
    | {
        id: string;
        email: string;
        firstName?: string;
        lastName?: string;
        country?: string | null;
      }
    | undefined
): void {
  const { consentForAnalytics } = useUserConsent();

  useEffect(() => {
    if (user && consentForAnalytics) {
      identifyMixpanelUser({
        id: user.id,
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
        country: user.country ?? undefined,
      });
    }
  }, [user, consentForAnalytics]);
}
